'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createAction = require('./createAction');

var _createAction2 = _interopRequireDefault(_createAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createAction2.default)('Batch', function () {
  for (var _len = arguments.length, actions = Array(_len), _key = 0; _key < _len; _key++) {
    actions[_key] = arguments[_key];
  }

  if (actions.length === 1 && Array.isArray(actions[0])) {
    return actions[0];
  }
  return actions;
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-act/lib/batch.js
 ** module id = 518
 ** module chunks = 1
 **/